import React, { useEffect, useState } from "react";
import {
  PayPalScriptProvider,
  PayPalButtons,
  FUNDING,
} from "@paypal/react-paypal-js";
import {
  Button,
  FormGroup,
  Label,
  Input,
  Col,
  InputGroup,
  FormFeedback,
  FormText,
} from "../BasicComponents";
import styles from './index.module.css';
import { paypal_key, paypal_server } from "../../constants";

function PaymentModal(props) {
  const [paymentMethod, setPaymentMethod] = useState(0);
  const [cardNumber, setCardNumber] = useState("");
  const [expMonth, setExpMonth] = useState(0);
  const [expYear, setExpYear] = useState(2023);
  const [cvv, setCVV] = useState("");
  const [name, setName] = useState("");
  var [cardValid, setCardValid] = useState(0);
  const [promoValid, setPromoValid] = useState(0);
  const [promoLoading, setPromoLoading] = useState(false);
  const [promo, setPromo] = useState("");
  const [promoApply, setPromoApply] = useState(false);

  const FUNDING_SOURCES = [FUNDING.PAYPAL, FUNDING.CARD];

  function formatDate(date) {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    return `${day}/${month}/${year}`;
  }
  
  // Add one month to a date
  function addOneMonth(date) {
    const newDate = new Date(date);
    const currentMonth = newDate.getMonth();
    newDate.setMonth(currentMonth + 1);
    
    // Handle cases where the original date was the last day of the month
    if (newDate.getMonth() !== (currentMonth + 1) % 12) {
      newDate.setDate(0);
    }
    return newDate;
  }
  
  // Add one year to a date
  function addOneYear(date) {
    const newDate = new Date(date);
    newDate.setFullYear(newDate.getFullYear() + 1);
    return newDate;
  }

  const initialOptions = !props.subscription
    ? {
        "client-id": paypal_key,
        currency: "USD",
        components: "buttons",
        "data-sdk-base-url": paypal_server + "proxy/paypal-sdk"
      }
    : {
        "client-id": paypal_key,
        components: "buttons",
        intent: "subscription",
        vault: true,
        "data-sdk-base-url": paypal_server + "proxy/paypal-sdk"
      };

  return !props.subscription ? (
    <PayPalScriptProvider options={initialOptions}>
    <PayPalButtons
      style={{
        shape: "rect",
        layout: "vertical",
        color: "gold",
        label: "paypal",
      }}
      createOrder={async () => {
        try {
          const response = await fetch(
            paypal_server + "api/orders",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              // use the "body" param to optionally pass additional order information
              // like product ids and quantities
              body: JSON.stringify({
                coins: props.coins * 10
              }),
            },
          );

          const orderData = await response.json();

          if (orderData.id) {
            return orderData.id;
          } else {
            const errorDetail = orderData?.details?.[0];
            const errorMessage = errorDetail
              ? `${errorDetail.issue} ${errorDetail.description} (${orderData.debug_id})`
              : JSON.stringify(orderData);

            throw new Error(errorMessage);
          }
        } catch (error) {
          console.error(error);
          console.log(`Could not initiate PayPal Checkout...${error}`);
        }
      }}
      onApprove={async (data, actions) => {
        try {
          document.getElementById('modalClose').click();
          const response = await fetch(
            `${paypal_server}api/orders/${data.orderID}/capture`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                coins: props.coins,
                token: localStorage.getItem('chesscloud-token')
              }),
            },
          );

          const orderData = await response.json();
          // Three cases to handle:
          //   (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
          //   (2) Other non-recoverable errors -> Show a failure message
          //   (3) Successful transaction -> Show confirmation or thank you message

          const errorDetail = orderData?.details?.[0];

          if (errorDetail?.issue === "INSTRUMENT_DECLINED") {
            // (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
            // recoverable state, per https://developer.paypal.com/docs/checkout/standard/customize/handle-funding-failures/
            return actions.restart();
          } else if (errorDetail) {
            // (2) Other non-recoverable errors -> Show a failure message
            throw new Error(
              `${errorDetail.description} (${orderData.debug_id})`,
            );
          } else {
            props.setAlertText(
              "Order Completed !",
            );
            props.setAlertType(true);
            props.setShowAlert(true);
            setTimeout(() => props.setShowAlert(false), 3000);
          }
        } catch (error) {
          console.error(error);
          console.log(
            `Sorry, your transaction could not be processed...${error}`,
          );
        }
      }}
    />
  </PayPalScriptProvider>
  ) : (
    <PayPalScriptProvider options={initialOptions}>
      {(
          FUNDING_SOURCES.map((fundingSource) => {
            return (
              <PayPalButtons
                fundingSource={fundingSource}
                key={fundingSource}
                style={{
                  layout: "vertical",
                  shape: "rect",
                  color: "",
                }}
                createSubscription={async (data, actions) => {
                  return actions.subscription.create({
                   //  plan_id: 'P-90S9036882138633DMXY7LNA',
                    plan_id: props.coinsub ? (props.yearly ? (props.plan === 0 ? 'P-7FR96164US367343HMZ2G4VY' : props.plan === 1 ? 'P-1ER31279AM685230KMZ2G55A' : 'P-36043643BR965123PMZ2G6TY') : (props.plan === 0 ? 'P-79W65807FE0055249M572O5I' : props.plan === 1 ? 'P-3NC6774619047862TM572SGQ' : 'P-3G9371068Y0019911M572SZI')) : (props.yearly ? (props.plan === 0 ? 'P-07N06286HD590291AMSQCTQY' : props.plan === 1 ? 'P-2NS07150FX479652LMSQCURY' : 'P-551124616E686673GMSQCVWQ') : (props.plan === 0 ? 'P-993958640B690204RMSQCSQQ' : props.plan === 1 ? 'P-3GG920251F7428647MSQCUDI' : 'P-2C929448LS3619610MSQCVEI')),
                    quantity: "1",
                  });
                }}
                onApprove={async (data, actions) => {
                  console.log(data);
                  try {
                    const response = await fetch(
                      `${paypal_server}orders/${data.subscriptionID}/capture`,
                      {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({token: localStorage.getItem('chesscloud-token')})
                      },
                    );

                    const details = await response.json();
                    document.getElementById('modalClose').click();
                    if (details.error == undefined) {
                      if (
                        details.transactions != undefined &&
                        details.transactions.length > 0
                      ) {
                        const transaction = details.transactions[0];
                        if (transaction.status == "COMPLETED") {
                         props.setPlan(props.plan);
                          props.setSubDate(props.yearly ? formatDate(addOneYear(new Date())) : formatDate(addOneMonth(new Date())));
                          props.setSubAmount(props.coinsub ? (props.yearly ? (props.plan === 0 ? '246.0' : props.plan === 1 ? '696.0' : '1236.0') : (props.plan === 0 ? '26.0' : props.plan === 1 ? '75.0' : '180.0')) : (props.yearly ? (props.plan === 0 ? '72.0' : props.plan === 1 ? '300.0' : '1200.0') : (props.plan === 0 ? '7.0' : props.plan === 1 ? '30.0' : '120.0')));
                          props.setAlertType(true);
                          props.setAlertText(
                            "Congrats ! Your transaction was successful",
                          );
                          props.setShowAlert(true);
                          setTimeout(() => {
                            props.setShowAlert(false);
                          }, 3000);
                        } else {
                          props.setAlertType(false);
                          props.setAlertText(
                            "Transaction could not be completed ! The recived status is:" +
                              transaction.status,
                          );
                          props.setShowAlert(true);
                          setTimeout(() => {
                            props.setShowAlert(false);
                          }, 3000);
                        }
                      } else {
                        props.setAlertType(false);
                        props.setAlertText(
                          "Transaction not found ! Please contact us if this error persists",
                        );
                        props.setShowAlert(true);
                        setTimeout(() => {
                          props.setShowAlert(false);
                        }, 3000);
                      }
                    } else {
                      props.setAlertType(false);
                      props.setAlertText(
                        "Transaction not found ! Please contact us if this error persists",
                      );
                      props.setShowAlert(true);
                      setTimeout(() => {
                        props.setShowAlert(false);
                      }, 3000);
                    }
                  } catch (error) {
                    console.error(error);
                    // Handle the error or display an appropriate error message to the user
                  }
                }}
              />
            );
          })
        )}
    </PayPalScriptProvider>
  );
}

export default PaymentModal;
